import React from "react";

const SalesBoostCard = () => {
  return (
    <div className="flex justify-center items-center mx-auto bg-[#EAF5FE] text-center whitespace-wrap py-20 px-12 rounded-md">
      <p className="text-gray-700 text-3xl font-semibold">
        Streamlining DMS boosts sales by{" "}
        <span className="text-[#0D89C8] font-bold">37%</span> through improved<br></br>
        efficiency and dealer/customer management.
      </p>
    </div>
  );
};

export default SalesBoostCard;
